export var paginationTheme = {
  baseStyle: {
    container: {
      display: 'inline-flex',
      alignItems: 'center'
    },
    paginationText: {
      marginRight: 's',
      textStyle: 'body4'
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      textStyle: 'body4',
      columnGap: 'm'
    }
  }
};
//# sourceMappingURL=Pagination.theme.js.map